// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"231":"component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx","715":"component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx"}[chunkId] + "-" + {"231":"63db34729daa7a3006e0","715":"f9dc0f38b0d7d019c569"}[chunkId] + ".js";
};